import React from 'react';
import './App.css';
import firebase from './Firestore';
import DigiturkLogo from './Assets/1200px-Digiturk_logo.png'
import Poster from './Assets/futbol.PNG';

const database = firebase.firestore();

class App extends React.Component {
  state = {
    registries: [],
    nameSurname: "",
    phoneNumber: "",
    registired: false,
    error: "",
  }

  componentDidMount() {
    database.collection('registries').get()
      .then(response => {
        let fetchedRegistries = [];
        response.docs.forEach(document => {
          fetchedRegistries.push(document.data());
        })
        this.setState({ registries: fetchedRegistries })
      })
  }

  render() {
    return (
      <div className="container">
        <div className="row upper-row bg-dark mb-2 mt-2 rounded">
          <img className="digiturk-logo m-2" src={DigiturkLogo} alt="digiturk-logo" />
          {this.renderDealerInfo()}
        </div>
        <div className="row lower-row bg-dark mb-2 rounded">
          <div class="col-7">
            <img className="poster bg-dark m-1 ml-2 mt-4 mb-4" src={Poster} alt="poster" />
          </div>
          <div class="col-5" >
            <div className="right-column">
              {this.renderSlogan()}
              {this.renderRegistryForm()}
              {this.renderAlert()}
            </div>
          </div>
        </div>

      </div>
    )
  }

  renderAlert() {
    if (this.state.registired) {
      return this.renderSuccessAlert();
    } else if (this.state.error) {
      return this.renderErrorAlert();
    } else {
      return ""
    }
  }

  renderSuccessAlert() {
    return (
      <div class="alert alert-success alert-dismissible">
        <a onClick={this.onDismissAlert} href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong>Kayıt başarılı.</strong> En kısa süre içinde sizinle iletişime geçeceğiz.
      </div>
    )
  }

  renderErrorAlert() {
    return (
      <div class="alert alert-danger alert-dismissible">
        <a onClick={this.onDismissAlert} href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong>{this.state.error}</strong> Lütfen bizimle iletişime geçiniz:  0530 703 50 60
      </div>
    )
  }

  renderDealerInfo() {
    return (
      <div class="dealer-info text-right">
        0342 231 74 84
        <br />
        0530 703 50 60
      </div>
    )
  }

  renderSlogan() {
    return (
      <h3 className="text-white">Size ulaşalım!</h3>
    )
  }

  renderRegistryForm() {
    return (
      <React.Fragment>
        <form >
          {this.renderNameSurnameGroup()}
          {this.renderPhoneNumberGroup()}
          <button type="submit" class="btn btn-primary" onClick={this.onSubmit}>Kaydol</button>
        </form>
      </React.Fragment>
    )
  }

  renderNameSurnameGroup() {
    return (
      <div class="form-group">
        <label for="nameSurnameInput" className="text-white">İsim Soyisim</label>
        <input type="email" class="form-control" id="nameSurnameInput" aria-describedby="emailHelp" placeholder="İsim soyisim giriniz."
          value={this.state.nameSurname}
          onChange={this.onNameSurnameChange}
        />
      </div>
    )
  }

  renderPhoneNumberGroup() {
    return (
      <div class="form-group">
        <label for="phoneNumberInput" className="text-white">Telefon Numarası</label>
        <input type="email" class="form-control" id="phoneNumberInput" aria-describedby="emailHelp" placeholder="Telefon numarası giriniz."
          value={this.state.phoneNumber}
          onChange={this.onPhoneNumberChange} />
      </div>
    )
  }

  onNameSurnameChange = (event) => {
    const nameSurname = event.target.value;
    this.setState({ nameSurname: nameSurname });

  }

  onPhoneNumberChange = (event) => {
    const phoneNumber = event.target.value;
    this.setState({ phoneNumber: phoneNumber });
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.postOneRegistry();

    this.setState({
      nameSurname: "",
      phoneNumber: ""
    })

    console.log("registired")
  }

  onDismissAlert = () => {
    this.setState({
      registired: false,
      error: ""
    })
  }

  postOneRegistry = () => {


    if (this.state.phoneNumber.trim() === '') {
      console.log("Phone number must not be empty");
    }

    if (this.state.nameSurname.trim() === '') {
      console.log("Name must not be empty");
    }

    const newRegistryItem = {
      name: this.state.nameSurname,
      phone: this.state.phoneNumber,
      createdAt: new Date().toISOString()
    }

    console.log(newRegistryItem)

    database
      .collection('registries')
      .add(newRegistryItem)
      .then(docRef => {
        console.log("Document generated with id: " + docRef.id)
        this.setState({ registired: true })
      })
      .catch(error => {
        console.log("Error registiring" + error)
        this.setState({ error: error })
      })



  }




}


export default App;
